import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared.module';
import { CreateLabControllerDialogComponent } from './create-lab-controller-dialog.component';


@NgModule({
  declarations: [CreateLabControllerDialogComponent],
  imports: [
    CommonModule,
    SharedModule,
  ],
  exports:[CreateLabControllerDialogComponent]
})
export class CreateLabControllerDialogModule { }
